// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"ro-z","breadcrumbForward":"so-z","breadcrumbBack":"to-z","selected":"uo-z"};